import { sv } from "@dhx/ts-common/dom";
import { getColorShade } from "../helpers/common";
import { PointType } from "../types";


export function hoverMode(cfg){
	// cfg.fill = cfg.stroke; ??
	return cfg;
}

export function standarMode(cfg){
	return cfg;
}

const forms = {
	circle(color, fill, _alpha, x, y, id, mode){
		const config = {
			"_ref": id,
			"cx": x,
			"cy": y,
			"r": 4,
			"class": "figure point-circle",
			fill,
			"stroke": color,
			"stroke-width": 2
		};

		return sv("circle", mode(config));
	},
	rect(color, fill, _alpha, x, y, id, mode){
		const config = {
			"_ref": id,
			"x": x - 4,
			"y": y - 4,
			"width": 8,
			"height": 8,
			"class": "figure point-rect",
			fill,
			"stroke": color,
			"stroke-width": 2
		};

		return sv("rect", mode(config));
	},
	rhombus(color, fill, _alpha, x, y, id, mode){
		const config = {
			"_ref": id,
			"points": `${x - 5},${y} ${x},${y + 5} ${x + 5},${y} ${x},${y - 5}`,
			"class": "figure point-rhombus",
			fill,
			"stroke": color,
			"stroke-width": 2
		};

		return sv("polygon", mode(config));
	},
	triangle(color, fill, _alpha, x, y, id, mode){
		const config = {
			"_ref": id,
			"points": `${x},${y - 5} ${x + 5},${y + 5} ${x - 5},${y + 5}`,
			"class": "figure point-triangle",
			fill,
			"stroke": color,
			"stroke-width": 2
		};

		return sv("polygon", mode(config));
	},
	simpleCircle(color, _fill, _alpha, x, y, id, mode){
		const config = {
			_ref: id,
			cx: x,
			cy: y,
			r: 3,
			class: "figure point-simple-circle",
			fill: color
		};

		return sv("circle", mode(config));
	},
	simpleRect(color, _fill, _alpha, x, y, id, mode){
		const config = {
			_ref: id,
			x: x - 3,
			y: y - 3,
			width: 6,
			height: 6,
			class: "figure point-simple-rect",
			fill: color
		};
		return sv("rect", mode(config));
	},
	empty(){
		return null;
	}
};

export function getHelper(type:PointType){
	const helper = forms[type.toString()];
	if (!helper){
		throw new Error("unknown point type");
	}
	return helper;
}

type drawFn = (x: number, y: number, id: string) => any;

export function getShadeHelper(type:PointType, color:string, mode:any): drawFn {
	const helper = getHelper(type);

	color = color || "none";
	const shade = getColorShade(color, 0.2);


	return function(x: number, y: number, id: string){
		return helper(color, shade, "", x, y, id, mode);
	};
}

